import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useOrganicRegistrationForm } from '..';
import Verification from '../../../../../assets/icons/Verification';
import Button from '../../../../../components/styledComponents/Button';
import colors from '../../../../../constants/colors';
import { useSnackbarsContext } from '../../../../../store/SnackbarProvider';
import SplitView from '../../../SplitView';

const ClubSsoVerificationMethod = () => {
  const navigate = useNavigate();
  const { otvcValues } = useOrganicRegistrationForm();
  const { closeSnackbar, enqueueSnackbar } = useSnackbarsContext();

  useEffect(() => {
    closeSnackbar();

    if (!otvcValues?.smsEligible && !otvcValues?.emailEligible) {
      navigate('/club/register', { replace: true });
    }
  }, []);

  return (
    <SplitView
      data-testid="organic-registration-otvc-sso-1"
      Icon={<Verification />}
    >
      <Stack
        direction="column"
        sx={{
          justifyContent: { mobile: 'flex-start', desktop: 'center' },
          px: { mobile: 2, tablet: 14, desktop: 11 },
          height: '100%'
        }}>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 700,
            fontSize: { mobile: 33, tablet: 44 },
            lineHeight: { mobile: '48px', desktop: '56px' },
          }}
        >
          Verification code
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            fontSize: { mobile: 23, tablet: 28 },
            lineHeight: { mobile: '32px', desktop: '40px' },
            mt: 1,
            color: colors.csaaDark,
          }}
        >
          We&apos;ll send you a one-time code to help you sign up.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Cabin',
            fontWeight: 400,
            fontSize: { mobile: 14, tablet: 16 },
            lineHeight: '24px',
            mt: 3,
            color: colors.csaaDark,
          }}
        >
          How would you like to receive your code?
        </Typography>
        <Stack
          direction={{ mobile: 'column', tablet: 'row' }}
          spacing={2}
          sx={{
            justifyContent: "space-between",
            mt: { mobile: 3, tablet: 5 }
          }}>
          <Button
            onClick={() => {
              closeSnackbar();
              navigate('email');
            }}
            data-testid="email-otvc-link"
            role="link"
            fullWidth
          >
            Email
          </Button>
          <Button
            onClick={() => {
              closeSnackbar();
              navigate('sms');
            }}
            role="link"
            data-testid="sms-otvc-link"
            fullWidth
          >
            Text
          </Button>
        </Stack>
      </Stack>
    </SplitView>
  );
};

export default ClubSsoVerificationMethod;
